var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlovakia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 20,
    viewBox: "0 0 34 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "SLOVAKIA_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_55814",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000143609800834889512290000007087892848173986432_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.5669 0.105469H0.00390625V19.6825H33.5669V0.105469Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_55814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.5669 0.105469H0.00390625V19.6825H33.5669V0.105469Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_55814",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000143609800834889512290000007087892848173986432__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M33.5669 0.105469H0.00390625V19.6825H33.5669V0.105469Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_55814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M33.5669 6.63184H0.00390625V19.6838H33.5669V6.63184Z",
    fill: "#2534A4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11472_55814",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000143609800834889512290000007087892848173986432__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M33.5669 0.105469H0.00390625V19.6825H33.5669V0.105469Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11472_55814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M33.5669 13.1562H0.00390625V19.6823H33.5669V13.1562Z",
    fill: "#BC0030"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11472_55814",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000143609800834889512290000007087892848173986432__4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M33.5669 0.105469H0.00390625V19.6825H33.5669V0.105469Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11472_55814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11472_55814",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000074423862077306074920000002693534539828018622_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M33.5669 0.105469H0.00390625V19.6825H33.5669V0.105469Z",
    fill: "white"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11472_55814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M5.07802 4.70729C4.68702 4.73729 4.79702 5.21528 4.75002 5.48528C4.60702 7.35828 4.41599 9.29031 4.98799 11.1143C5.43699 12.5833 6.51699 13.7983 7.82399 14.5813C8.14199 14.7603 8.45703 14.9853 8.81203 15.0823C9.18703 14.9773 9.51501 14.7423 9.84901 14.5533C11.136 13.7713 12.187 12.5663 12.636 11.1153C13.218 9.26128 13.011 7.29728 12.868 5.39528C12.847 5.13228 12.886 4.67929 12.499 4.70729H5.07802Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11472_55814",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000074423862077306074920000002693534539828018622__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M33.5669 0.105469H0.00390625V19.6825H33.5669V0.105469Z",
    fill: "white"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11472_55814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M8.81312 4.99805V14.787C4.28612 12.594 4.78211 8.96405 5.07911 4.99805H8.81312ZM8.81312 4.99805V14.787C13.3401 12.594 12.8441 8.96405 12.5471 4.99805H8.81312Z",
    fill: "#BC0030"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_11472_55814",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000074423862077306074920000002693534539828018622__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M33.5669 0.105469H0.00390625V19.6825H33.5669V0.105469Z",
    fill: "white"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_11472_55814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M9.34149 7.68372C9.81649 7.68372 10.3025 7.77172 10.7695 7.86472C10.6325 7.41172 10.6325 7.13271 10.7695 6.67871C10.3025 6.77271 9.81649 6.85971 9.34149 6.85971H8.28253C7.80753 6.85971 7.32349 6.77271 6.85449 6.67871C6.99149 7.13271 6.99149 7.41072 6.85449 7.86472C7.32349 7.77172 7.80753 7.68372 8.28253 7.68372H9.34149Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_11472_55814",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000074423862077306074920000002693534539828018622__4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M33.5669 0.105469H0.00390625V19.6825H33.5669V0.105469Z",
    fill: "white"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_11472_55814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M9.75232 9.46793C10.2313 9.46793 10.7133 9.55392 11.1803 9.64792C11.0433 9.19392 11.0433 8.91591 11.1803 8.46191C10.7133 8.55491 10.2313 8.64191 9.75232 8.64191H7.87531C7.39431 8.64191 6.91031 8.55491 6.44531 8.46191C6.58031 8.91591 6.58031 9.19392 6.44531 9.64792C6.91031 9.55392 7.39431 9.46793 7.87531 9.46793H9.75232Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_11472_55814",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000074423862077306074920000002693534539828018622__5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M33.5669 0.105469H0.00390625V19.6825H33.5669V0.105469Z",
    fill: "white"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_11472_55814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M8.21484 5.37402C8.31284 5.84002 8.40082 6.32102 8.40082 6.79602V12.86H9.22681V6.79602C9.22681 6.32102 9.31281 5.84002 9.40881 5.37402C8.95081 5.51302 8.67184 5.51302 8.21484 5.37402Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_11472_55814",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000074423862077306074920000002693534539828018622__6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M33.5669 0.105469H0.00390625V19.6825H33.5669V0.105469Z",
    fill: "white"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_11472_55814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M6.93182 11.3887C6.39882 11.3887 5.96484 11.8227 5.96484 12.3537C5.96484 12.3957 5.96679 12.4347 5.97479 12.4737C6.16079 12.7497 6.3808 13.0137 6.6308 13.2717C6.7248 13.3007 6.82582 13.3227 6.93182 13.3227C7.47282 13.3227 7.9068 12.8887 7.9068 12.3537C7.9058 11.8217 7.47282 11.3887 6.93182 11.3887Z",
    fill: "#2534A4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_11"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_11472_55814",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000074423862077306074920000002693534539828018622__7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M33.5669 0.105469H0.00390625V19.6825H33.5669V0.105469Z",
    fill: "white"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_11472_55814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M8.81311 10.8154C8.13111 10.8154 7.57715 11.3704 7.57715 12.0484C7.57715 12.7264 8.13211 13.2774 8.81311 13.2774C9.49411 13.2774 10.0491 12.7254 10.0491 12.0484C10.0491 11.3704 9.49411 10.8154 8.81311 10.8154Z",
    fill: "#2534A4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_12"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_11472_55814",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000074423862077306074920000002693534539828018622__8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M33.5669 0.105469H0.00390625V19.6825H33.5669V0.105469Z",
    fill: "white"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_11472_55814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M10.6907 11.3887C10.1577 11.3887 9.72168 11.8227 9.72168 12.3537C9.72168 12.8887 10.1567 13.3227 10.6907 13.3227C10.7997 13.3227 10.8977 13.3017 10.9917 13.2717C11.2457 13.0137 11.4667 12.7487 11.6517 12.4717C11.6577 12.4347 11.6657 12.3947 11.6657 12.3537C11.6657 11.8217 11.2267 11.3887 10.6907 11.3887Z",
    fill: "#2534A4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_13"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_11472_55814",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000074423862077306074920000002693534539828018622__9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M33.5669 0.105469H0.00390625V19.6825H33.5669V0.105469Z",
    fill: "white"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_11472_55814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M6.12305 12.6836C6.72105 13.4776 7.57405 14.1896 8.81305 14.7886C10.053 14.1886 10.905 13.4776 11.501 12.6836H6.12305Z",
    fill: "#2534A4"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlovakia);
export default __webpack_public_path__ + "static/media/SLOVAKIA.78521aac46363cb5950fe6a9282cb6cd.svg";
export { ForwardRef as ReactComponent };